/*
 * @Description: 二次确认弹层
 * @Date: 2019-12-31 14:53:59
 * @LastEditTime: 2022-10-12 16:42:42
 */
export const makeSure = {
  methods: {
    /**
     * @description: 确认操作，需要兼容之前mixin
     * @param Function 回调
     * @param Object 当前数据
     * @param String 提示
     * @return: void
     */
    makeSureEvent(cb, row = null, text = '是否确定保存?') {
      return new Promise((resolve, reject) => {
        this.$confirm(text, {
          // FIX: 添加loading
          async beforeClose(action, instance, done) {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              try {
                await cb(row);
                resolve('ok');
                done();
              } catch (e) {
                reject(e);
                done();
              }
              instance.confirmButtonText = '确定';
              instance.confirmButtonLoading = false;
            } else {
              done();
            }
          }
        })
          .then(() => {})
          .catch(() => {
            this.$message('取消操作');
          });
      });
    },
    changeBackground(val) {}
  }
};
